import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  > div {
    > div {
      border: none;
    }
  }

  h2 {
    font: ${font('default', 'normal', '16px/1')};
  }

  a {
    ${props => props.theme.css.link};
  }
`
